import { html } from 'BomdisoftComponents/html/index';

// Allowlists hex/named colors and CSS color functions (rgb(), oklch(), light-dark(), var(), ...);
// excludes <, >, ", ', ;, {, }, / so a malformed value can't break out of the <style> tag below.
const VALID_CSS_COLOR = /^[a-zA-Z0-9#(),.\-%\s]+$/;

export const toSafePrimaryColor = (primaryColor: string | undefined) => (primaryColor && VALID_CSS_COLOR.test(primaryColor) ? primaryColor : undefined);

export const toThemeOverrideRule = (safePrimaryColor: string) => `html:root{--bomdisoft-primary:${safePrimaryColor}}`;

export const renderThemeOverride = (primaryColor: string | undefined) => {
  const color = toSafePrimaryColor(primaryColor);
  return color ? html`<style>${toThemeOverrideRule(color)}</style>` : html``;
};
